<template>
  <!-- <button @click="loginWITHeMAIL">Go to LMS</button> -->
  <div
    class="flex flex-col gap-4 items-center justify-center h-screen bg-white"
  >
    <!-- Loading -->
    <div v-if="loading" class="text-center">
      <div
        class="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid mx-auto"
      ></div>
      <p class="mt-4 text-gray-600 text-lg">Logging you in...</p>
    </div>

    <!-- Error -->
    <div v-if="error" class="text-center">
      <p class="text-red-500 text-lg">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      loading: true,
      error: "",
      refresh_token: process.env.VUE_APP_REFRESH_TOKEN,
      access_token: process.env.VUE_APP_ACCESS_TOKEN,
    };
  },

  computed: mapGetters(["userInfo"]),

  created() {
   

    const urlParams = new URLSearchParams(window.location.search);
    const email_id = urlParams.get("email_id");
    const access_token = urlParams.get("access_token");
    const refresh_token = urlParams.get("refresh_token");
    if (!email_id || !access_token || !refresh_token) {
      this.error = "Missing token. Redirecting to login...";
      setTimeout(() => {
        this.loading = false;
        this.loginredirect();
      }, 1000);

      return;
    } else {
      this.error = "Logging in...";
      this.loginWITHeMAIL(email_id, access_token, refresh_token);
    }
  },

  methods: {
    ...mapMutations(["setUserInfo", "StorePermisson"]),

    loginWITHeMAIL(email_id, access_token, refresh_token) {
      // https://al-lms-api.galecta.com/sso/login/?access_token=-06CdVUP1UojrCGh7t0kae02oYTSQCYmEKnNr8ep8tM&refresh_token=vO0fvbNyKXpFrHk7kqWsRuIMnhqfYJ54PwnwUwk8_DLZ5tpoQ75DilpBWpl-6VG4AL7fPfV3wXyoICVaoukzAA

      // let refresh_token = 'vO0fvbNyKXpFrHk7kqWsRuIMnhqfYJ54PwnwUwk8_DLZ5tpoQ75DilpBWpl-6VG4AL7fPfV3wXyoICVaoukzAA'
      // let access_token = '-06CdVUP1UojrCGh7t0kae02oYTSQCYmEKnNr8ep8tM';

      axios
        .post(
          `${process.env.VUE_APP_API}/sso/login/?access_token=${access_token}&refresh_token=${refresh_token}`,
          {
            email: email_id,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.setUserInfo(response.data);

            axios
              .get(
                `${process.env.VUE_APP_API}/features/?Key=${response.data.token_key}`
              )
              .then((resp) => {
                if (resp.data.code == 200) {
                  // this.permisson_list = resp.data.message[0].features;
                  this.StorePermisson(resp.data.message[0].features);
                  // this.user_count = resp.data.user_count;
                }
              });

            setTimeout(() => {
              // this.getNotifications(this.userInfo);
              if (
                this.userInfo &&
                this.userInfo.user &&
                this.userInfo.user.permission
              ) {
                const role = this.userInfo.user.permission;

                if (role === "student") {
                  this.$router.push({ name: "StudentHome" });
                } else if (role === "instructor") {
                  this.$router.push({ name: "InstructorHome" });
                } else if (role === "hod") {
                  this.$router.push({ name: "HodHome" });
                } else if (role === "mentor") {
                  this.$router.push({ name: "MentorHome" });
                } else if (role === "co-ordinator") {
                  this.$router.push({ name: "CoordinateHome" });
                } else if (role === "super_admin") {
                  this.$router.push({ name: "AdminHome" });
                } else {
                  this.$router.push({
                    name: "organizationDashboard",
                    params: { slug_id: this.userInfo.slug_id },
                  });
                }
                this.error = "";
                this.loading = false;
              }
            }, 1000);
          } else {
            this.error = "Invalid role. Cannot redirect.";
          }
          if (response.data.status == 400) {
            this.error = "Something went wrong during login.";
            this.loading = false;
          }
        })
        .catch((error) => {
          this.error = "something went wrong";
          console.log(error);
        });
    },

    loginredirect() {
      this.$router.push({
        name: "Login",
      });
    },
  },
};
</script>
